import { render } from "./StockTransfers.vue?vue&type=template&id=0c4d163a&scoped=true"
import script from "./StockTransfers.vue?vue&type=script&lang=js"
export * from "./StockTransfers.vue?vue&type=script&lang=js"

import "./StockTransfers.vue?vue&type=style&index=0&id=0c4d163a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4d163a"]])

export default __exports__